import { apiClient } from './apiClient';
// const scopeKey = 'lead management';
const BASE_URL = '/v1/otp-service';

export interface Status {
    statusMessage: string;
    statusCode: number;
    entities: object;
}

export interface OTPResponse {
    data: Status;
    message: string;
    success: boolean;
}

export const otpService = {
    gerateOTP: async (
        emailAddress: string,
        scopeKey: string
    ): Promise<Status> => {
        const response = await apiClient.post<any>(
            `${BASE_URL}/generate-otp/${emailAddress}?scopeKey=${scopeKey}`,
            {}
        );
        return response.data;
    },
    verigyOTP: async (
        emailAddress: string,
        enteredOTP: number,
        scopeKey: string
    ): Promise<Status> => {
        const response = await apiClient.post<OTPResponse>(
            `${BASE_URL}/validate-otp/${emailAddress}/${enteredOTP}?scopeKey=${scopeKey}`,
            {}
        );
        return response.data;
    }
};
